import toast from 'react-hot-toast'

export const notifySuccess = (message) => toast.success(message);
export const notifyError = (message) => toast.error(message);
export const notifyInfo = (message) => toast(message, { icon: 'ℹ️' });
export const notifyWarning = (message) => toast(message, { icon: '⚠️' });

const NOTIFY_BY_TYPE = {
    success: notifySuccess,
    error: notifyError,
    warning: notifyWarning,
    info: notifyInfo,
};

// Islands funnel every card's onToast({ type, text }) through here; an unknown type is shown as info.
export const notifyByType = (type, message) => (NOTIFY_BY_TYPE[type] || notifyInfo)(message);
